export default __webpack_public_path__ + "static/media/EditDisable.55014542.svg";